/* global $ */
import Events from '../../../../javascript/src/config/events'
import registerOutsideClickListener from '$lib/outside_event_listener'
import { hideNavBackdrop, showNavBackdrop } from '$lib/navigation_backdrop_helper'

export default class NavigationSearchBar {
  get searchNamespace() {
    return '.js-navigation-search-bar'
  }

  get toggleSearchField() {
    return '.js-toggle-search-button'
  }

  get openedSearchBarClass() {
    return 'js-navigation-search-bar--open'
  }

  get hiddenNavigationClass() {
    return 'navigation__links--hidden'
  }

  get navigationToggle() {
    return '.js-toggle-navigation'
  }

  get inputPrefix() {
    return '.navigation-search-bar__input'
  }

  get breadcrumbs() {
    return '.breadcrumbs'
  }

  get navigation() {
    return '.navigation'
  }

  constructor() {
    this.$ns = $(this.searchNamespace)
    this.$whatField = this.$ns.find(`${this.inputPrefix}--what`)
    this.$navigationToggle = $(this.navigationToggle)

    this.initTrackingFields()
    this.initBehavior()
  }

  initTrackingFields() {
    const whatField = this.$whatField
    const whereField = this.$ns.find(`${this.inputPrefix}--where`)
    const whatTrackingField = $('#t_nav_search_bar_what')
    const whereTrackingField = $('#t_nav_search_bar_where')

    whatField.on('change', () => {
      this.copyValueToField(whatTrackingField, whatField.val())
    })

    whereField.on('change', () => {
      this.copyValueToField(whereTrackingField, whereField.val())
    })

    this.copyValueToField(whatTrackingField, whatField.val())
    this.copyValueToField(whereTrackingField, whereField.val())
  }

  copyValueToField(field, value) {
    field.val(value)
  }

  hideSearch() {
    hideNavBackdrop()
    if($(this.navigation).hasClass('navigation--fixed')){
      $('.navigation__login').css('background', '#f5f5f5')
      $('.navigation__link-text').css('background', '#f5f5f5')
      $('.navigation').css('background-color', '#fff')
      $('.breadcrumbs').css('background-color', '#fff')
    }

    this.$ns.removeClass(this.openedSearchBarClass)
    this.$navigationToggle.css('z-index', 5)

    this.toggleUiChange()
  }

  showSearch() {
    showNavBackdrop()
    if($(this.navigation).hasClass('navigation--fixed')){
      $('.navigation__login').css('background-color', '#8B8B8B')
      $('.navigation__link-text').css('background-color', '#8B8B8B')
      $('.navigation').css('background-color', '#8B8B8B')
      $('.breadcrumbs').css('background-color', '#8B8B8B')
    }

    this.$ns.addClass(this.openedSearchBarClass)
    this.$navigationToggle.css('z-index',4)
    this.toggleUiChange()

    this.$ns.trigger(Events.ON_NAVIGATION_SEARCH_OPEN)
    this.$whatField.trigger('focus')

    registerOutsideClickListener(this.searchNamespace, () => {
      this.hideSearch()
    })
  }

  toggleUiChange() {
    $(this.navitagionToggle).toggleClass('pe-none')
  }

  initBehavior() {
    this.$ns.find(this.toggleSearchField).on('click', () => {
      if (this.$ns.hasClass(this.openedSearchBarClass)) {
        this.hideSearch()
      } else {
        this.showSearch()
      }
    })
  }
}
